const column = [
  {
    name:'首页',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[
      {
        name:'专业介绍',
        to:'/desc',
        type:1,
        params:{
          id:56
        },
      },
    ],
    params:{},
    img:'',
    introduce:''
  },
  {
    name:'学校概况',
    to:'',
    type:2,
    img:'b01.jpg',
    introduce:'秉承“坚持、创新、高效、开放、追求卓越”的办学理念',
    children:[
      {
        // 这里直接展示的填写文档ID（新闻ID）
        name:'学校简介',
        to:'/evn/content',
        type:1,
        params:{
          id:8,
        },
      },
      {
        name:'项目介绍',
        to:'/evn/content',
        type:2,
        params:{
          id:454,
          template:'notice'
        },
      },
      {
        name:'规章制度',
        to:'/evn/content',
        type:1,
        params:{
          id:498
        },
      },
      {
        name:'交通指引',
        to:'/evn/content',
        type:1,
        params:{
          id:470
        },
      },
      {
        name:'学院风光',
        to:'/evn/list',
        type:1,
        params:{
          id:15,
          template:'nev'
        },
      },
    ],
  },
  {
    name:'信息公开',
    to:'',
    type:2,
    img:'b02.jpg',
    introduce:'秉承“坚持、创新、高效、开放、追求卓越”的办学理念',
    children:[
      {
        name:'校内新闻',
        to:'/evn/list',
        type:2,
        params:{
          id:18,
          template:'media'
        },
      },
      {
        name:'通知公告',
        to:'/evn/list',
        type:2,
        params:{
          id:19,
          template:'notice'
        },
      },
      {
        name:'人才招聘',
        to:'/evn/list',
        type:2,
        params:{
          id:20,
          template:'media'
        },
      },
    ],
  },
  {
    name:'党建思政',
    to:'',
    type:2,
    img:'b03.jpg',
    introduce:'秉承“坚持、创新、高效、开放、追求卓越”的办学理念',
    children:[
      {
        name:'党建在线',
        to:'/evn/list',
        type:2,
        params:{
          id:21,
          template:'media'
        },
      },
    ],
  },
  {
    name:'招生就业',
    to:'',
    type:2,
    img:'b04.jpg',
    introduce:'秉承“坚持、创新、高效、开放、追求卓越”的办学理念',
    children:[
      {
        name:'自考助学',
        to:'/evn/list',
        type:2,
        params:{
          id:22,
          template:'media'
        },
      },
      {
        name:'学历提升',
        to:'/evn/list',
        type:2,
        params:{
          id:23,
          template:'media'
        },
      },
      {
        name:'国际培训',
        to:'/evn/list',
        type:2,
        params:{
          id:24,
          template:'media'
        },
      },
      {
        name:'就业指导',
        to:'/evn/list',
        type:2,
        params:{
          id:25,
          template:'media'
        },
      },

    ],
  },
  // {
  //   name:'招生就业',
  //   to:'/enroll',
  //   type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
  //   children:[],
  //   params:{},
  //   img:'b05.jpg',
  //   introduce:''
  // },
  {
    name:'走进校园',
    to:'',
    type:2,
    img:'b06.jpg',
    introduce:'秉承“坚持、创新、高效、开放、追求卓越”的办学理念',
    children:[
      {
        name:'校园活动',
        to:'/evn/list',
        type:2,
        params:{
          id:33,
          template:'media'
        },
      },
      {
        name:'学习之星',
        to:'/evn/list',
        type:2,
        params:{
          id:34,
          template:'media'
        },
      },
      {
        name:'美食专栏',
        to:'/evn/list',
        type:2,
        params:{
          id:35,
          template:'media'
        },
      },
      {
        name:'好书推荐',
        to:'/evn/list',
        type:2,
        params:{
          id:36,
          template:'media'
        },
      },
    ],
  },
  {
    name:'联系我们',
    to:'/evn/content?id=0&pid=6',
    type:1,
    img:'b07.jpg',
    introduce:'秉承“坚持、创新、高效、开放、追求卓越”的办学理念',
    children:[
      {
        name:'联系我们',
        to:'/evn/content',
        type:1,
        params:{
          id:471
        },
      },
    ],
  },
  {
    name:'公共服务',
    to:'',
    type:9,
    img:'',
    introduce:'秉承“坚持、创新、高效、开放、追求卓越”的办学理念',
    children:[
      {
        name:'学期日历',
        to:'/evn/list',
        type:2,
        params:{
          id:61,
          template:'media'
        },
      },
    ],
  },
];

const enrollColumn = [
  {
    name:'本站首页',
    to:'/enroll/index',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{},
    img:'',
    introduce:''
  },
  {
    name:'学院概况',
    to:'/evn/content?id=0&pid=1',
    type:1,
    children:[],
    img:'',
    introduce:'',
    params:{
      id:0
    },
  },
  {
    name:'招生信息',
    to:'',
    type:2,
    img:'',
    introduce:'',
    status:0,
    params:{
      id:0
    },
    children:[
      {
        name:'招生计划',
        to:'/enroll/article/list',
        type:1,
        params:{
          category_id:3
        },
      },
      {
        name:'收费一览',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:18
        },
      },
      {
        name:'录取程序',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:2
        },
      },
      {
        name:'证书样本',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:16
        },
      },
    ],
  },
  {
    name:'招生动态',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:7
    },
  },
  {
    name:'网上报名',
    to:'/sign',
    type:3,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:8
    },
  },
  {
    name:'常见问答',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:9
    },
  },
  {
    name:'资料下载',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:10
    },
  },
  {
    name:'联系我们',
    to:'/enroll/article/content',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      article_id:13
    },
  },
  {
    name:'学院首页',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{
    },
    img:'',
    introduce:''
  },
];
export default {
  column,
  enrollColumn
}



// WEBPACK FOOTER //
// ./src/utils/params.js